import React from 'react';
import { TopLocationRole } from 'lib/types/replay';
import { pluralize } from 'lib/helpers';
import { roleMapping } from './roleMapping';

export interface Slide2Props {
  topLocationRole: TopLocationRole;
}

/** Slide 2 - Top Percentiles, either metric OR platform */
export const Slide02 = ({
  topLocationRole,
}: Slide2Props) => {
  const roleName = roleMapping[topLocationRole.roleId]?.plural.toUpperCase()
    || pluralize(topLocationRole?.role).toUpperCase();

  return (
    <div className="absolute inset-0 text-white text-center w-full h-full">
      <div className="absolute top-[25%] left-1/2 -translate-x-1/2 w-full">
        <div className="text-2xl font-light animate-flyup">
          YOU&apos;RE IN THE
        </div>
        <div className="font-bold text-[9rem] leading-none animate-flyleft">
          TOP
          <br />
          {Math.max(1, (topLocationRole.percentile * 100)).toFixed(0)}
          %
        </div>
        <div className="md:text-2xl text-xl pt-5 font-light animate-flyright">
          {topLocationRole.type === 'top_location' ? 'OF GONDOLA CREATORS' : `OF ${roleName}`}
        </div>
        <div className="text-xl uppercase animate-flyleft">
          {topLocationRole.type === 'top_role' ? 'IN 2025' : (
            <>
              IN
              {' '}
              {topLocationRole.location}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
